import { Component, OnInit } from '@angular/core';
import { AccountBalanceService } from 'src/app/services/balance/account-balance.service';
import { BalanceModel } from 'src/app/models/balance-model';
import { GameHubControllerService } from 'src/app/services/gameHub/game-hub-controller';
import { PopoverController } from '@ionic/angular';
import { ConfigService } from 'src/app/services/config/config.service';
import { Platform } from '@ionic/angular';
import { EventsService } from 'src/app/services/event/event.service';



@Component({
  selector: 'app-restricted-money',
  templateUrl: './restricted-money.html',
  styleUrls: ['./restricted-money.scss'],
})
export class RestrictedMoneyPopover implements OnInit {
  public availableMoney = 0;
  public restrictedMoney = 0;
  public accountBalances: BalanceModel;
  public error: string | null = null;

  constructor(
    private balanceService: AccountBalanceService,
    private config: ConfigService,
    private eventsService: EventsService,
    private gameHubController: GameHubControllerService,
    private platform: Platform,
    private popOverCtrl: PopoverController,
  ) { }

  ngOnInit() {

    const dismissTimeout = +this.config.getConfig().FEATURE_POPOVER_DISMISS_TIMER || 15000
    setTimeout(() => {
      if (dismissTimeout > 0) {
        this.popOverCtrl.dismiss(true);
      }
    }, dismissTimeout);
    this.getBalance();
    localStorage.removeItem('skipActiveBonusCheck');
  }

  onConfirm() {
    if (this.platform.is("mobileweb") || this.platform.is("capacitor")) {
      this.eventsService.publish("game:confirm:start");
    }
    const gameData = this.gameHubController.restrictedGameData;
    this.gameHubController.restrictedGameData = null;

    if (gameData) {
      localStorage.setItem('skipActiveBonusCheck', 'true');
      this.gameHubController.launchCasinoGame(gameData);
    }
    this.popOverCtrl.dismiss(true);
  }

  private getBalance(): void {
    this.balanceService.getBalance().subscribe(
      (balance) => {
        if (balance) {
          this.accountBalances = balance;
          this.availableMoney = this.accountBalances[this.accountBalances.DEFAULT_CURRENCY].availableBalance;
          this.restrictedMoney = this.accountBalances[this.accountBalances.DEFAULT_CURRENCY].restrictedBalance;
        }
      }
    );

    this.error = null;
  }

  onClose = () => {
    this.eventsService.publish("event:siteheader:show");
    this.popOverCtrl.dismiss(true);
  }

}
